import { useIntl } from "react-intl";

import City from "forms/fields/ContactData/partials/City";
import Country from "forms/fields/ContactData/partials/Country";
import Region from "forms/fields/ContactData/partials/Region";
import type { ShortContactDataProps } from "forms/fields/ContactData/types";
import useContactData from "forms/fields/ContactData/useContactData";
import { Fieldset } from "ui/Fieldset";

export default function ShortContactData({ control, country, region, allOf, city }: ShortContactDataProps) {
    const { formatMessage } = useIntl();
    const { regionDictionary } = useContactData({ allOf });

    return (
        <Fieldset title={formatMessage({ id: "contact_data" })}>
            {country && <Country control={control} data={country} />}

            {region && regionDictionary && <Region control={control} data={region} options={regionDictionary} />}

            {city && <City control={control} data={city} />}
        </Fieldset>
    );
}
